import { Feature, ProgramFeature } from './models';
export enum FeatureNames {
    EvacuationOrderLocations = 'EvacuationOrderLocations',
    IssuingLocations = 'IssuingLocations',
    PaymentDeclarations = 'PaymentDeclarations',
    Events = "Events",
    ApplicationGenerationTracking = "ApplicationGenerationTracking"
}

export const isFeatureEnabled = (
    featureName: FeatureNames,
    features: Feature[],
    programFeatures: ProgramFeature[]
) => {
    const filteredFeature = features.find(
        f => f.name === FeatureNames[featureName]
    );
    const isEnabled = programFeatures.some(
        pf => pf.featureId === filteredFeature?.id && pf.isEnabled
    );
    return isEnabled;
};

export const getFeatureDisplayName = (
    featureName: FeatureNames,
    features: any[]
) => {
    return features.find(f => f.name === FeatureNames[featureName])
        ?.displayName;
};
